import { render, staticRenderFns } from "./BuildingCardWrapper.vue?vue&type=template&id=21be6630&"
import script from "./BuildingCardWrapper.vue?vue&type=script&lang=js&"
export * from "./BuildingCardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BuildingCardWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports